import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, DestroyRef, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { Observable } from 'rxjs';
import { ClickOutsideDirective } from '../../directives/click-outside.directive';
import { SessionState, SessionStore } from '../../services/session.store';

@Component({
  selector: 'sidenav',
  templateUrl: './sidenav.component.html',
  styleUrls: ['./sidenav.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RouterLink, RouterLinkActive, AsyncPipe, ClickOutsideDirective],
})
export class SidenavComponent {
  readonly state$: Observable<SessionState>;

  readonly userMenuOpen = signal(false);

  constructor(
    private store: SessionStore,
    private destroyRef: DestroyRef
  ) {
    this.state$ = this.store.state$;
  }

  toggleUserMenu(): void {
    this.userMenuOpen.update(open => !open);
  }

  closeUserMenu(): void {
    this.userMenuOpen.set(false);
  }

  // Ustawienia is not daily work: no sidenav icon, and only for whoever may manage users (0058)
  canManageUsers(): boolean {
    return this.store.can('UsersManage');
  }

  signOut(): void {
    this.store.signOut().pipe(takeUntilDestroyed(this.destroyRef)).subscribe();
  }

  // "Karol Hinz" → "KH"; a single word gives its first letter
  initials(displayName: string): string {
    return displayName
      .split(' ')
      .filter(part => part)
      .slice(0, 2)
      .map(part => part[0].toUpperCase())
      .join('');
  }
}
